import { makeStyles, Box } from '@material-ui/core'
import Alert from '@material-ui/lab/Alert'
import { Progress } from '@backstage/core-components'

import { HomeAnnouncementBanner } from '@internal/plugin-announcements'
import { OwnershipCard } from '../OwnershipCard'
import { EntityProvider } from '@backstage/plugin-catalog-react'
import { EntityTechInsightsOverviewCard } from '@internal/plugin-tech-insights-overview'

import { useMyBaAndPod } from '../../hooks/my-group'
import { EntityCloudCostCard } from '@internal/plugin-cloud-cost'
import { UserGroupCard } from './UserGroupCard'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2)
  }
}))

export function AboveTheFold() {
  const classes = useStyles()

  const { value, loading, error } = useMyBaAndPod()

  if (loading) {
    return <Progress />
  }

  if (error) {
    return <Alert severity="error">{error.message}</Alert>
  }

  if (!value) {
    // Impossible branch
    return (
      <Alert severity="error">
        Unexpected kukurookoo. Please, report to Cloud Platform team.
      </Alert>
    )
  }

  if (value.error) {
    return <Alert severity="error">{value.error}</Alert>
  }

  const { baEntity, podEntity } = value

  return (
    <EntityProvider entity={podEntity ?? baEntity}>
      <Box className={classes.root}>
        <Box mb={2}>
          <HomeAnnouncementBanner />
        </Box>
        {(podEntity || baEntity) && (
          <Box mb={2}>
            <UserGroupCard podEntity={podEntity} baEntity={baEntity} />
          </Box>
        )}
        <Box mb={2}>
          <EntityCloudCostCard />
        </Box>
        {(podEntity || baEntity) && (
          <Box>
            <Box mb={2}>
              <OwnershipCard
                hideRelationsToggle
                relationsType="aggregated"
                groupBy="kind"
              />
            </Box>
            <Box mb={2}>
              <EntityTechInsightsOverviewCard />
            </Box>
          </Box>
        )}
      </Box>
    </EntityProvider>
  )
}
